import React, { useMemo } from 'react';
import type { CommandPaletteBodyProps } from '../../../../common/types';
import { components } from '../../../../common/ui/components';
import { getActiveCommandList } from '../../../../common/utils/get-active-command-list';
import { useCommandPaletteExpandedCommand } from '../../../../controllers';

export const Body = ({
	fallback,
	results,
	total,
	renderAfterCommands,
}: CommandPaletteBodyProps) => {
	const [{ expandedCommand }, { setChildCommands, setLoadingList, setFallbackOverride }] =
		useCommandPaletteExpandedCommand();
	const ExpandedBody = useMemo(
		() =>
			getActiveCommandList(expandedCommand, expandedCommand?.wasSecondaryTriggered)?.components
				?.Body || components.Body,
		[expandedCommand],
	);

	return (
		<ExpandedBody
			setChildResult={setChildCommands}
			setLoading={setLoadingList}
			fallback={fallback}
			results={results}
			total={total}
			renderAfterCommands={renderAfterCommands}
			setFallbackOverride={setFallbackOverride}
		/>
	);
};
